import { FC } from "react";
import { Outlet, useLocation } from "react-router-dom";

import { WelcomeText } from "@/components/Portal/Cockpit/WelcomeText/WelcomeText";
import { portalRoutes } from "@/router/routes/portalRoutes";

/**
 * Layout for cockpit routes (`/portal/cockpit` and nested pages such as
 * ID check). The greeting is only shown on the dashboard itself.
 */
export const Cockpit: FC = () => {
  const { pathname } = useLocation();
  const isDashboard =
    pathname === portalRoutes.cockpit.base ||
    pathname === `${portalRoutes.cockpit.base}/`;

  return (
    <div className="flex flex-col gap-6">
      {isDashboard && <WelcomeText />}

      <Outlet />
    </div>
  );
};
